import { Language } from 'prism-react-renderer'

const RE = /{([\d,-]+)}/

function getNumbersFromRageStr(rangeStr: string): number[] {
  try {
    const res = []
    const [start, end] = rangeStr.split('-').map(u => Number.parseInt(u, 10))
    for (let i = start; i <= end; i += 1) {
      res.push(i)
    }
    return res
  } catch {
    return []
  }
}

function rangeParser(strLineNumbers: string): Set<number> {
  const nums = strLineNumbers
    .split(',')
    .map(s => s.trim())
    .reduce((agg: number[], strNum) => {
      if (strNum.includes('-')) {
        agg.push(...getNumbersFromRageStr(strNum))
      } else {
        agg.push(Number.parseInt(strNum, 10))
      }
      return agg
    }, [])
  return new Set(nums)
}

export const getLinesToHighlight = (meta: string): Set<number> => {
  const possibleLineNumbers = RE.exec(meta)
  if (possibleLineNumbers) {
    const strLineNumbers = possibleLineNumbers[1]
    const lineNumbers = rangeParser(strLineNumbers)
    return lineNumbers
  }
  return new Set()
}

export const getParams = (className = ''): [Language | 'react', Record<string, any>] => {
  const [lang = '', params = ''] = className.split(':')
  return [
    (lang.split('language-').pop() || '').split('{').shift() as Language,
    params.split('&').reduce((merged, param) => {
      const [key, value] = param.split('=')
      return { ...merged, [key]: value }
    }, {}),
  ]
}
